import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeactivateGuard implements CanDeactivate<IDeactivatableComponent> {
  canDeactivate(
    component: IDeactivatableComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // console.log('DeactivateGuard.canDeactivate', component, route, state, nextState);
    if (component != null && typeof component.canDeactivate === 'function') {
      // not sure why sometimes null :\
      return component.canDeactivate(nextState?.url);
    }
    return true;
  }
}


export interface IDeactivatableComponent {
  canDeactivate: ( url?: string ) => Observable<boolean> | Promise<boolean> | boolean;
}
